import { NpSpinner } from "src/components/np-design/components/NpSpinner"

export const LoadingIndicator = () => {
  return (
    <output className="flex w-full justify-center p-12 text-gray-200">
      <NpSpinner />
    </output>
  )
}
